var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1134"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1134"
    },
    "bundlingPackage": "payments-ui-app",
    "bundlingPackageVersion": "static-1.27214",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};